import { Button, Form, Input } from 'antd';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IdcardOutlined, LoginOutlined } from '../../icons';
import { ApiError } from '../../lib/http';
import { login } from '../../services/auth';
import { getOrCreateDeviceId, setSession } from '../../stores/session';

const FOOTER =
  '成都市第二十中学校 · 四川省成都市金牛区育英路6号 · 蜀ICP备15006431号-2 · 厚德明理，励志笃行 · 情智并育、慧行天下';

export function KioskLoginPage() {
  const nav = useNavigate();
  const [principal, setPrincipal] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const disabled = !principal.trim() || !password;

  return (
    <div className="kiosk-shell">
      <header className="kiosk-header">
        <div>
          <div>成都市第二十中学校</div>
          <strong>大同科创共享中心预约平台</strong>
        </div>
      </header>
      <main className="kiosk-main" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div className="login-card" style={{ width: 480 }}>
          <h1>学号登录</h1>
          <Form layout="vertical">
            <Form.Item label="学号" validateStatus={error ? 'error' : undefined} help={error || undefined}>
              <Input
                size="large"
                prefix={<IdcardOutlined />}
                inputMode="numeric"
                value={principal}
                onChange={(e) => setPrincipal(e.target.value)}
                style={{ height: 56 }}
              />
            </Form.Item>
            <Form.Item label="密码">
              <Input.Password size="large" value={password} onChange={(e) => setPassword(e.target.value)} style={{ height: 56 }} />
            </Form.Item>
            <Button
              type="primary"
              icon={<LoginOutlined />}
              className="kiosk-primary"
              disabled={disabled}
              loading={loading}
              block
              onClick={async () => {
                setLoading(true);
                setError('');
                try {
                  const data = await login({
                    principal: principal.trim(),
                    password,
                    device_id: getOrCreateDeviceId(),
                  });
                  const token = data.access_token ?? data.token;
                  if (!token || !data.kiosk_session_id) {
                    throw new ApiError('一体机会话未建立', 50000, 500);
                  }
                  if (data.user.role !== 'student') {
                    setError('一体机仅供学生学号登录');
                    return;
                  }
                  setSession({ token, user: data.user, kioskSessionId: data.kiosk_session_id });
                  nav('/kiosk/courses', { replace: true });
                } catch (e) {
                  if (e instanceof ApiError && e.code === 0) setError(e.message);
                  else if (e instanceof ApiError && e.code === 42902) setError('尝试过多，请稍后');
                  else setError('学号或密码不正确');
                } finally {
                  setLoading(false);
                }
              }}
            >
              登录
            </Button>
          </Form>
          <p className="meta">教室公用设备，请在使用后退出。空闲 15 分钟后需重新登录。</p>
        </div>
      </main>
      <div className="app-footer">{FOOTER}</div>
    </div>
  );
}
